export const HERO_CONSTANTS = {
  button: {
    label: "Upgrade your cloud infrastructure today",
    link: "#contact-us",
  },
  content:
    "Unlock seamless virtualization with VMware Cloud, enabling hybrid, private, and multi-cloud strategies with high performance and reliability. Optimize your IT operations with a cloud platform that scales as you grow.",
  title: "Hybrid & Multi-Cloud Made Simple",
};
